import React from 'react';
import './index.css';
import App from './App';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from './context/ThemeContext';


const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// Register Progressive Web App Service Worker with auto-update capability
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('[PWA] Service Worker registered with scope:', registration.scope);

        // Check for updates on startup
        registration.update().catch(() => {});

        // Check for updates periodically every 3 minutes
        setInterval(() => {
          registration.update().catch(() => {});
        }, 3 * 60 * 1000);

        // Re-check for updates on window focus
        window.addEventListener('focus', () => {
          registration.update().catch(() => {});
        });

        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('[PWA] New version available! Activating update...');
                  installingWorker.postMessage({ type: 'SKIP_WAITING' });
                }
              }
            };
          }
        };
      })
      .catch(error => {
        console.error('[PWA] Service Worker registration failed:', error);
      });

    // Auto-reload window when new service worker takes control
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        const lastReload = sessionStorage.getItem('yaseero_auto_reload_ts');
        const now = Date.now();
        if (lastReload && now - Number(lastReload) < 5000) {
          return;
        }
        refreshing = true;
        console.log('[PWA] Controller changed - refreshing page to apply update');
        sessionStorage.setItem('yaseero_auto_reload_ts', now.toString());
        window.location.reload();
      }
    });
  });
}